import { getDeliveryClient } from './getDeliveryClient'

export function getNonLinkedItemsClient() {
	return getDeliveryClient({ linkedItemsReferenceHandler: 'ignore' })
}
